import React from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import { Container, Row, Col, Nav, Tab } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import '../../../assets/scss/sections/_tab.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';

const TabSection = ({ why_choose_us_data }) => {
  return (
    <>
      <section id="tab_wrapper">
        <Container className="tab_overlay">
          <Tab.Container id="left-tabs-example" defaultActiveKey="first">
            <Row>
              <Col sm={6}>
                <div className="tab_left">
                  <Nav variant="pills" className="flex-column tab_content_left">
                    {why_choose_us_data.map((team, index) => (
                      <Col sm={12} key={team.home_why_choose_us_id.toString()}>
                        <Nav.Item>
                          <Nav.Link
                            eventKey={
                              index === 0 ? 'first' : team.home_why_choose_us_id.toString()
                            }>
                            {team.title}
                            <span>
                              <FontAwesomeIcon icon={faAngleRight} />
                            </span>
                          </Nav.Link>
                        </Nav.Item>
                      </Col>
                    ))}
                  </Nav>
                </div>
              </Col>
              <Col sm={6}>
                <div className="tab_right">
                  <Tab.Content className="tab_content_right">
                    {why_choose_us_data.map((team, index) => (
                      <Tab.Pane
                        key={team.home_why_choose_us_id.toString()}
                        eventKey={index === 0 ? 'first' : team.home_why_choose_us_id.toString()}>
                        {Parser(team.description)}
                      </Tab.Pane>
                    ))}
                  </Tab.Content>
                </div>
              </Col>
            </Row>
          </Tab.Container>
        </Container>
      </section>

      <section id="according_section">
        <div className="according_wrapper">
          <Container>
            <Accordion defaultActiveKey="first">
              {why_choose_us_data.map((team, index) => (
                <Accordion.Item
                  key={team.home_why_choose_us_id.toString()}
                  eventKey={index === 0 ? 'first' : team.home_why_choose_us_id.toString()}>
                  <Accordion.Header> {team.title}</Accordion.Header>
                  <Accordion.Body> {Parser(team.description)}</Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Container>
        </div>
      </section>
    </>
  );
};
TabSection.propTypes = {
  why_choose_us_data: PropTypes.array,
};
export { TabSection };
